import { apiClient } from "@wtf/shared/api/utils/api-client";
import {
  TryOnPhoto,
  TryOnPhotoUploadRequest,
  TryOnPhotoUploadResponse,
  GenerateTryOnRequest,
  GenerateTryOnResponse,
  TryOnGeneration,
} from "@wtf/shared";

const BASE_ENDPOINT = "api/try-on";

/**
 * Get all try-on photos for the current user
 */
export async function getTryOnPhotos(): Promise<TryOnPhoto[]> {
  return apiClient<TryOnPhoto[]>(`${BASE_ENDPOINT}/photos`);
}

/**
 * Upload a new try-on photo to the user's gallery
 */
export async function uploadTryOnPhoto(data: TryOnPhotoUploadRequest): Promise<TryOnPhotoUploadResponse> {
  return apiClient<TryOnPhotoUploadResponse>(`${BASE_ENDPOINT}/photos`, "POST", data);
}

/**
 * Delete a try-on photo from the user's gallery
 */
export async function deleteTryOnPhoto(id: string): Promise<void> {
  return apiClient<void>(`${BASE_ENDPOINT}/photos/${id}`, "DELETE");
}

/**
 * Set a try-on photo as the user's default
 */
export async function setDefaultTryOnPhoto(id: string): Promise<TryOnPhoto> {
  return apiClient<TryOnPhoto>(`${BASE_ENDPOINT}/photos/${id}/default`, "PATCH");
}

/**
 * Generate a virtual try-on image
 */
export async function generateTryOn(data: GenerateTryOnRequest): Promise<GenerateTryOnResponse> {
  const { returnPresignedUrl, ...bodyData } = data;
  const queryParam = returnPresignedUrl ? '?returnPresignedUrl=true' : '';
  return apiClient<GenerateTryOnResponse>(`${BASE_ENDPOINT}/generate${queryParam}`, "POST", bodyData);
}

/**
 * Get all try-on generations for the current user
 */
export async function getTryOnGenerations(archived: boolean = false): Promise<TryOnGeneration[]> {
  return apiClient<TryOnGeneration[]>(`${BASE_ENDPOINT}/generations?archived=${archived}`);
}

/**
 * Archive a try-on generation
 */
export async function archiveTryOnGeneration(id: string): Promise<void> {
  return apiClient<void>(`${BASE_ENDPOINT}/generations/${id}/archive`, "PATCH");
}

/**
 * Unarchive a try-on generation
 */
export async function unarchiveTryOnGeneration(id: string): Promise<void> {
  return apiClient<void>(`${BASE_ENDPOINT}/generations/${id}/unarchive`, "PATCH");
}

export const tryOnApi = {
  getTryOnPhotos,
  uploadTryOnPhoto,
  deleteTryOnPhoto,
  setDefaultTryOnPhoto,
  generateTryOn,
  getTryOnGenerations,
  archiveTryOnGeneration,
  unarchiveTryOnGeneration,
};
